import { DefaultError } from 'errors/DefaultError';

export class ApiError extends DefaultError {
  constructor({ error, message, title }) {
    const shortMsg = `${error?.config?.method?.toUpperCase()} ${
      error?.config?.url
    } ${error?.status} (${error?.statusText})`;

    super({
      error: new Error(shortMsg),
      name: ApiError.name,
      message: message ?? `${shortMsg} ${JSON.stringify(error)}`,
      title
    });
    this.response = error.data;
  }

  static get name() {
    return 'ApiError';
  }
}
